export const parseDomainFromUrl = (url: string) => {
  const urlObj = new URL(url);
  return urlObj.hostname.replace(/^www\./, "");
};
